module.exports = __webpack_public_path__ + "img/ciclo-completo.9fd3dac6.gif";